import { render, staticRenderFns } from "./PaymentButtonSettings.vue?vue&type=template&id=317a9079&scoped=true&"
import script from "./PaymentButtonSettings.vue?vue&type=script&lang=js&"
export * from "./PaymentButtonSettings.vue?vue&type=script&lang=js&"
import style0 from "./PaymentButtonSettings.vue?vue&type=style&index=0&id=317a9079&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317a9079",
  null
  
)

export default component.exports